
import CommercialPresentation from "@/components/CommercialPresentation";
import { Helmet } from "react-helmet";
import { Download } from "lucide-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "sonner";

const Presentation = () => {
  const exportToPdf = async () => {
    toast.info("Preparing PDF, please wait...");
    
    const presentationElement = document.getElementById("presentation-container");
    
    if (!presentationElement) {
      toast.error("Could not find presentation content");
      return;
    }
    
    try {
      const canvas = await html2canvas(presentationElement, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
      
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
      });
      
      const imgWidth = 297; // A4 landscape width
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      pdf.save("benchr-commercial-presentation.pdf");
      
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("PDF generation error:", error);
      toast.error("Failed to generate PDF. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-benchr-100 dark:from-benchr-950 dark:to-benchr-900 p-4 md:p-8">
      <Helmet>
        <title>benchr.ai - Commercial Presentation</title>
        <meta name="description" content="Benchr's commercial presentation showcasing our e-commerce competitive intelligence platform capabilities" />
      </Helmet>
      
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-end mb-4">
          <button
            onClick={exportToPdf}
            className="flex items-center gap-2 bg-benchr-600 hover:bg-benchr-700 text-white rounded-lg px-4 py-2 shadow-md transition-colors"
          >
            <Download className="h-5 w-5" />
            <span>Download PDF</span>
          </button>
        </div>
        
        <div id="presentation-container">
          <CommercialPresentation />
        </div>
      </div>
    </div>
  );
};

export default Presentation;
